export const dateFormat = (date: Date) => {
  return new Date(date).toLocaleString().replace(',', ' -');
};
